import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { FINANCING_PATH } from "./data";

const FACTS = [["24", "rate al massimo"], ["0%", "TAN e TAEG"], ["9.000 €", "importo massimo"]];

export const FinancingTeaser = () => (
  <section className="py-20 sm:py-28" data-testid="financing-teaser">
    <div className="mx-auto max-w-[1400px] px-4 sm:px-10">
      <Reveal className="rounded-[2rem] bg-[#E6ECE4] p-7 sm:p-12 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <p className="eyebrow text-[#3E6B48]">Dilaziona il tuo preventivo</p>
          <h2 className="f-serif text-4xl sm:text-5xl text-[#1B3B28] leading-[1.02] mt-4">Hai già un preventivo? <em className="text-[#3E6B48]">Confrontiamolo insieme.</em></h2>
          <p className="text-[#526356] mt-5 leading-relaxed max-w-xl">Caricalo con la tua panoramica: ti diamo il nostro parere e una proposta, pagabile in comode rate a interessi zero.</p>
          <Link to={FINANCING_PATH} data-testid="financing-teaser-cta"
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[#1B3B28] text-[#FCFBF7] pl-6 pr-2 py-2 text-sm hover:bg-[#3E6B48] transition-colors">
            Simula la tua rata
            <span className="grid place-items-center w-8 h-8 rounded-full bg-[#86C89B] text-[#0F2317] transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight size={15} /></span>
          </Link>
        </div>
        <div className="lg:col-span-5 grid grid-cols-3 gap-3">
          {FACTS.map(([n, l]) => (
            <div key={l} className="rounded-2xl bg-[#FCFBF7] p-4 sm:p-5">
              <p className="f-serif text-2xl sm:text-4xl text-[#1B3B28] leading-none whitespace-nowrap">{n}</p>
              <p className="text-xs text-[#526356] mt-2 leading-snug">{l}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
